import React from "react";
import { CollapsibleFormSection } from "../../common/CollapsibleFormSection";

interface RiskBehavioursSectionProps {
  values: string[];
  otherValue: string;
  onCheckboxChange: (value: string, checked: boolean) => void;
  onOtherChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  className?: string;
}

const OPTIONS = [
  "Striking out e.g. hitting, kicking",
  "Self injury",
  "Yelling or screaming aggressively",
  "Throwing objects",
  "Running away or attempting to leave school grounds",
  "Threatening others verbally or physically",
  "Damaging property",
  "Physically blocking others or invading personal space",
  "Intense crying, sobbing, or emotional breakdown",
  "Loss of rational communication (e.g. cursing, shouting nonsensically)",
  "Biting or spitting",
];

export const RiskBehavioursSection: React.FC<RiskBehavioursSectionProps> = ({
  values,
  otherValue,
  onCheckboxChange,
  onOtherChange,
  className,
}) => (
  <CollapsibleFormSection
    title="Select/describe the student's severe challenging or risk behaviours."
    className={className}
  >
    <div className="form-group checkbox-group brp-checkbox-group">
      {OPTIONS.map((option) => {
        const isSelected = values.includes(option);
        return (
          <label
            key={option}
            className={`checkbox-item brp-checkbox-item ${
              isSelected ? "selected" : ""
            }`}
          >
            <input
              type="checkbox"
              checked={isSelected}
              onChange={(e) => onCheckboxChange(option, e.target.checked)}
            />
            <span className="checkbox-custom brp-checkbox-custom"></span>
            <span className="checkbox-label">{option}</span>
          </label>
        );
      })}
    </div>
    <div className="brp-wide-input-container" style={{ marginTop: 16 }}>
      <label className="other-input-label" htmlFor="riskBehavioursOther">
        Other:
      </label>
      <input
        type="text"
        id="riskBehavioursOther"
        name="riskBehavioursOther"
        value={otherValue}
        onChange={onOtherChange}
        className="other-input brp-wide-input"
      />
    </div>
  </CollapsibleFormSection>
);
